module.exports = __webpack_public_path__ + "img/img1.fe9af6df.png";